//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@core/utils/filter'
// eslint-disable-next-line object-curly-newline
import {
  mdiAttachment,
  mdiStarOutline,
  mdiStar,
  mdiDotsVertical,
  mdiReplyOutline,
  mdiReplyAllOutline,
  mdiForward,
} from '@mdi/js'

export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  setup() {
    // Single Message Actions
    const singleMessageActions = [
      { title: 'Reply', icon: mdiReplyOutline },
      { title: 'Reply All', icon: mdiReplyAllOutline },
      { title: 'Forward', icon: mdiForward },
    ]

    return {
      // Single Message Actions
      singleMessageActions,

      // UI Filters
      formatDate,

      // Icons
      icons: {
        mdiAttachment,
        mdiStarOutline,
        mdiStar,
        mdiDotsVertical,
      },
    }
  },
}
